export const serviceImages = {
  "depannage-plomberie": {
    url: "https://static.prod-images.emergentagent.com/jobs/fd61461c-3fdd-4e18-a4ac-4a27fc4b9c09/images/6a77e74bd90ea1272388e3bb7b299e7e69134b7e64721dd33b724231c768dbe4.png",
    alt: "Réparation de plomberie sous un évier par un artisan professionnel",
  },
  "installation-sanitaire": {
    url: "https://static.prod-images.emergentagent.com/jobs/fd61461c-3fdd-4e18-a4ac-4a27fc4b9c09/images/8ea7569c2ccca42a702b2ad86b09ecba0582be7f7a7bb144a66d0b5249d54f52.png",
    alt: "Salle de bain moderne avec douche à l'italienne et WC suspendu",
  },
  "chauffage": {
    url: "https://static.prod-images.emergentagent.com/jobs/fd61461c-3fdd-4e18-a4ac-4a27fc4b9c09/images/a56735d37cc7ec398e52d21798935b256f74cc4de59fbccc32b7855bb6a75eb0.png",
    alt: "Radiateur moderne installé dans un salon lumineux",
  },
  "recherche-de-fuites": {
    url: "https://static.prod-images.emergentagent.com/jobs/fd61461c-3fdd-4e18-a4ac-4a27fc4b9c09/images/a3bd6effcd9b479ce46744472e9cb63421f652ed2d02ada3445867371640d566.png",
    alt: "Détection de fuite avec un appareil professionnel sur un mur",
  },
  "renovation-salle-de-bain": {
    url: "https://static.prod-images.emergentagent.com/jobs/fd61461c-3fdd-4e18-a4ac-4a27fc4b9c09/images/c48ae4aeb84a6ba1fe187e3e3c116b3252f4bf1a7b42bc190c41e227541393b6.png",
    alt: "Salle de bain rénovée avec baignoire îlot et double vasque",
  },
  "urgence-plomberie": {
    url: "https://static.prod-images.emergentagent.com/jobs/fd61461c-3fdd-4e18-a4ac-4a27fc4b9c09/images/8733038e50d32c653764fe4698a02b4c4f0288b80ffbbb57b7ff10a45e04b848.png",
    alt: "Fuite d'eau urgente sous un meuble de cuisine",
  },
  "entretien-chaudiere": {
    url: "https://static.prod-images.emergentagent.com/jobs/fd61461c-3fdd-4e18-a4ac-4a27fc4b9c09/images/1677bbb9f2c320433e8e7d2f9a68cb0289e14287f4f78c823522f8a27e8b3b40.png",
    alt: "Technicien effectuant l'entretien annuel d'une chaudière murale",
  },
  "hero-residential": {
    url: "https://static.prod-images.emergentagent.com/jobs/fd61461c-3fdd-4e18-a4ac-4a27fc4b9c09/images/1ed6ba17c802201e981b2403ff41bc26c61bbdaf18dfe5d82920b16447a3c68d.png",
    alt: "Installation sanitaire et chaudière murale dans un logement",
  },
  "hero-boiler": {
    url: "https://static.prod-images.emergentagent.com/jobs/fd61461c-3fdd-4e18-a4ac-4a27fc4b9c09/images/d1eac5a6fad4de6ce0ebfc4ae8f9d218be31470b7e35f21b29327cbf186d525b.png",
    alt: "Chaudière murale à condensation installée proprement",
  },
};
